import { render, staticRenderFns } from "./ConfirmShippingModal.vue?vue&type=template&id=19b87c66"
import script from "./ConfirmShippingModal.vue?vue&type=script&lang=js"
export * from "./ConfirmShippingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports